import {
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  MenuItem,
  Stack,
  TextField as MuiTextField,
} from '@mui/material';
import { ReactElement, useState, useEffect, useCallback } from 'react';
import {
  CreateButton,
  Datagrid,
  EditButton,
  TextField,
  useTranslate,
  DeleteButton,
  FunctionField,
  useNotify,
  NumberField,
  useRefresh,
} from 'react-admin';
import Chip from '@mui/material/Chip';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import CreateIntervention from './Create';
import RecordsForm from '../records/recordForm';

const InterventionList = () => {
  const translate = useTranslate();
  const [popup, setPopup] = useState<ReactElement>();
  const refresh = useRefresh();
  return (
    <PermissionGuard resource="redpacket" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('module.redpacket.intervention')}
          links={[
            { name: translate('module.redpacket.redPacketManagement'), href: `/${Resources.redpacket}` },
            { name: translate('module.redpacket.intervention') },
          ]}
          action={
            <PermissionGuard resource="redpacket" action="create" fallback={<></>}>
              <CreateButton
                variant="contained"
                size="medium"
                onClick={(e) => {
                  e.preventDefault();
                  setPopup(
                    <CreateIntervention
                      onClose={() => {
                        setPopup(undefined);
                        refresh()
                      }}
                    />
                  );
                }}
              />
            </PermissionGuard>
          }
        />

        <RecordsForm />

        {popup && (
          <Dialog open maxWidth="md" fullWidth>
            {popup}
          </Dialog>
        )}
      </DashboardContent>
    </PermissionGuard>
  );
};

export default InterventionList;
